import e from "./ghl-ui.es1506.js";
import o from "./ghl-ui.es1466.js";
function i(t) {
  o(1, arguments);
  var r = e(t);
  return r.setMilliseconds(0), r;
}
export {
  i as default
};
